<div class="square-revenue-dialog" mat-dialog-content>
    <h2>Pay Payroll</h2>
    
    <div class="container">

        <div class="left">
            <ngx-dropzone (change)="submitAbr($event)">
                <ngx-dropzone-label>Upload ABR</ngx-dropzone-label>
            </ngx-dropzone>
        </div>

        <div class="right">
            <div class="transfers">
                <div class="transfer" *ngFor="let transfer of transfers">
                    <mat-form-field class="description" appearance="outline" subscriptSizing="dynamic">
                        <input matInput [(ngModel)]="transfer.transactionDescription" placeholder="Description">
                    </mat-form-field>
                    <ap-money class="amount" [outline]="true" [inDollars]="true" [(amount)]="transfer.amount"></ap-money>
                </div>

                <div class="transfer totalReconilled">
                    <div class="label">Total: </div>
                    <div class="amount">{{getTotal()*100 | human}}</div>
                </div>
            </div>

            <!-- <div>Total Fees: {{feesTotal | human}}</div> -->
        </div>
    </div>
</div>

<div class="actions" mat-dialog-actions>
    <button (click)="save()" mat-raised-button>Save</button>
    <button (click)="clear()" mat-raised-button>Clear</button>
    <button (click)="commit()" class="commit" mat-raised-button>Commit</button>
</div>